/** Shared quick prompts & capabilities for Qore AI surfaces */
export const QUICK_PROMPTS = [
  { id: 'concept', icon: 'book', labelKey: 'aiTutoring.quickExplainConcept', promptKey: 'aiTutoring.promptExplainConcept' },
  { id: 'debug', icon: 'code', labelKey: 'aiTutoring.quickDebugCode', promptKey: 'aiTutoring.promptDebugCode' },
  { id: 'labs', icon: 'flask', labelKey: 'aiTutoring.quickVirtualLabs', promptKey: 'aiTutoring.promptVirtualLabs' },
  { id: 'courses', icon: 'graduation', labelKey: 'aiTutoring.quickExploreCourses', promptKey: 'aiTutoring.promptExploreCourses' },
  { id: 'start', icon: 'rocket', labelKey: 'aiTutoring.quickGettingStarted', promptKey: 'aiTutoring.promptGettingStarted' },
  { id: 'career', icon: 'briefcase', labelKey: 'aiTutoring.quickCareerHelp', promptKey: 'aiTutoring.promptCareerHelp' },
];

export const CAPABILITIES = [
  { id: 'courses', icon: 'graduation', labelKey: 'aiTutoring.capCourses' },
  { id: 'code', icon: 'code', labelKey: 'aiTutoring.capCode' },
  { id: 'labs', icon: 'flask', labelKey: 'aiTutoring.capLabs' },
  { id: 'career', icon: 'briefcase', labelKey: 'aiTutoring.capCareer' },
];

export const PAGE_CONTEXT_LABELS = {
  'student-portal': 'aiTutoring.ctxStudentPortal',
  academy: 'aiTutoring.ctxAcademy',
  course: 'aiTutoring.ctxCourse',
  'learning-path': 'aiTutoring.ctxLearningPath',
  'virtual-labs': 'aiTutoring.ctxVirtualLabs',
  career: 'aiTutoring.ctxCareer',
  'qore-talks': 'aiTutoring.ctxQoreTalks',
  community: 'aiTutoring.ctxCommunity',
  mentorship: 'aiTutoring.ctxMentorship',
  skills: 'aiTutoring.ctxSkills',
  'ai-tutoring': 'aiTutoring.ctxAITutoring',
  home: 'aiTutoring.ctxHome',
  general: 'aiTutoring.ctxGeneral',
};